import React, { useState } from "react";
import { functions } from "../../../firebase";
import { Button } from "../../../design/button";
import { Supervisor } from "@visitproof/types";
import {
  Alert,
  AlertActions,
  AlertBody,
  AlertTitle,
} from "../../../design/alert";
import { httpsCallable } from "firebase/functions";

interface Props {
  supervisor: Supervisor;
}

const ReactivateButton: React.FC<Props> = ({ supervisor }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      const reactivateSupervisor = httpsCallable(
        functions,
        "reactivateSupervisor",
      );
      await reactivateSupervisor({
        supervisorId: supervisor.id,
      });
      setIsOpen(false);
    } catch (error) {
      alert("Failed to reactivate the monitor. Please try again later.");
    }
    setIsSubmitting(false);
  };

  return (
    <>
      <Button color="green" type="button" onClick={() => setIsOpen(true)}>
        Reactivate
      </Button>
      <Alert open={isOpen} onClose={setIsOpen}>
        <AlertTitle>Reactivate Monitor</AlertTitle>
        <AlertBody>
          Are you sure you want to reactivate this supervisor? They will regain
          access to their account, and billing for this seat will resume on your
          next invoice.
        </AlertBody>
        <AlertActions>
          <Button plain onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button color="green" disabled={isSubmitting} onClick={handleSubmit}>
            {isSubmitting ? "Reactivating..." : "Reactivate"}
          </Button>
        </AlertActions>
      </Alert>
    </>
  );
};

export default ReactivateButton;
